import { useTranslation } from "react-i18next";
import { SettingRow, TextInput, Section } from "./SettingsControls";

interface FilePathSettingsProps {
    bdtPath: string;
    padPath: string;
    saved: boolean;
    dirty?: boolean;
    onBdtChange: (v: string) => void;
    onPadChange: (v: string) => void;
    onSave: () => void;
}

export function FilePathSettings({ bdtPath, padPath, saved, dirty, onBdtChange, onPadChange, onSave }: FilePathSettingsProps) {
    const { t } = useTranslation();
    return (
        <Section title={t("settings.fileLocations")}>
            <SettingRow title={t("settings.bdtFileLocation")} description={t("settings.bdtFileLocationDesc")}>
                <TextInput value={bdtPath} onChange={onBdtChange} placeholder="/path/to/file.bdt" />
            </SettingRow>
            <SettingRow title={t("settings.padFolderLocation")} description={t("settings.padFolderLocationDesc")}>
                <TextInput value={padPath} onChange={onPadChange} placeholder="/path/to/pad/" />
            </SettingRow>
        </Section>
    );
}
